import { httpRequest } from "@/erp_subpackage/utils/HttpRequest";

//discountPrice 优惠价  shopPrice 商场价 tradePrice 批发价 itemCode 商品编码  itemName 商品名称  
//categoryCode 所属分类  categoryName 所属分类名称

//详情
// export interface detailOne {
//     "id": "80"
//     "code": "80"
//     "typeCode": "80"
//     "typeName": "积改做老"
//     "attrCode": "69"
//     "attrName": "行情产克"
//     "name": "影消三再"
//     "answer": "答案"
//     "status": "状态"
//     "details": [
//         {
//             "id": "80"
//             "code": "80"
//             "key": "in in et Lorem"
//             "value": "minim"
//             "status": "in ea anim ipsum aliquip"
//         }
//     ]
// }

class QuestionService {
    async page(searchVo) {
        const apiUrl = "/ci-storage/questionBank/page";
        return await httpRequest.post(apiUrl, searchVo);
    }
    async one(id) {
        const apiUrl = `/ci-storage/questionBank/findByIdOrCode/${id}`;
        return await httpRequest.get(apiUrl);
    }
    async insert(insertVo) {
        const apiUrl = "/ci-storage/questionBank/insert";
        return await httpRequest.post(apiUrl, insertVo);
    }
    async update(updateVo) {
        const apiUrl = "/ci-storage/questionBank/update";
        return await httpRequest.post(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id, status) {
        const apiUrl = `/ci-storage/questionBank/enableOrDisable/${id}/${status}`;
        return await httpRequest.get(apiUrl);
    }
    //删除
    async remove(id) {
        const apiUrl = `/ci-storage/questionBank/delete/${id}`;
        return await httpRequest.get(apiUrl);
    }
    //导入
    async import(file) {
        const appPageUrl = "/ci-storage/questionBank/import";
        return await httpRequest.post(appPageUrl, file);
    }
    //导出
    async export(searchVo) {
        const appPageUrl = "/ci-storage/questionBank/export";
        return await httpRequest.postFile(appPageUrl, searchVo);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/ci-storage/questionBank/downloadTpl";
        return await httpRequest.getFile(apiUrl);
    }
    /**配置信息 */
    async settingOne(code) {
        const apiUrl = `/ci-storage/setting/findByCode/${code}`;
        return await httpRequest.get(apiUrl);
    }
    async settingInsert(insertVo) {
        const apiUrl = "/ci-storage/setting/insert";
        return await httpRequest.post(apiUrl, insertVo);
    }
    async settingUpdate(updateVo) {
        const apiUrl = "/ci-storage/setting/update";
        return await httpRequest.post(apiUrl, updateVo);
    }
}

export const questionService = new QuestionService();